module.exports = __webpack_public_path__ + "static/startup_banner_img-b143a12c46490825b7e0f05d5a8af715.png";